import { useEffect, useState } from 'react';
import { Client, useStompClient } from 'react-stomp-hooks';

import userActivityStore from '../store/UserActivityStore';

export const useDisableWebsocketOnCurrentPage = (): void => {
  const stompClient = useStompClient();
  const [cachedStompClient, setCachedStompClient] = useState<Client>();

  // disable websocket on page load
  useEffect(() => {
    if (stompClient?.active) {
      setCachedStompClient(stompClient);
      stompClient.deactivate();
      userActivityStore.updateBackgroundStatus(true);
    }
  }, [stompClient?.active]);

  // enable websocket on exiting page
  useEffect(() => {
    return () => {
      if (cachedStompClient && !cachedStompClient.active) {
        cachedStompClient.activate();
      }
    };
  }, [cachedStompClient]);
};
